export const SUBSCRIPTIONS_URL = `/api/v3/subscriptions/`;
